import { mockEmbeddedPartnersQueryData } from 'bundles/enterprise-learning-path-description-page/data/mockEmbeddedPartnersQuery';
import { mockVspPageQueryData } from 'bundles/enterprise-learning-path-description-page/data/mockVspPageQuery';

export const useEmbeddedPartnersData = () => {
  return { data: mockEmbeddedPartnersQueryData, isLoading: false, isError: false };
};

export const useVspPageData = () => {
  return { data: mockVspPageQueryData, isLoading: false, isError: false };
};
